import Vue from 'vue'
import App from './App.vue'
import router from './lib/router/router'
import store from './lib/store/store'
import { sync } from 'vuex-router-sync'
import firebase from 'firebase/app'
import { firebaseConfigDev } from './lib/firebase/firebase-config'
import 'firebase/firestore'
import 'firebase/storage'
import stats from './lib/stats/stats'

sync(store, router)

const firebaseConfigPromise =
  process.env.NODE_ENV === 'development'
    ? Promise.resolve(firebaseConfigDev)
    : fetch('/__/firebase/init.json').then(response => response.json())

firebaseConfigPromise.then(firebaseConfig => {
  Vue.prototype.$firebase = firebase
  Vue.prototype.$firebase.initializeApp(firebaseConfig)

  Vue.prototype.$storage = Vue.prototype.$firebase.storage()

  Vue.prototype.$firestore = Vue.prototype.$firebase.firestore()
  Vue.prototype.$firestore.settings({ timestampsInSnapshots: true })

  Vue.config.productionTip = false
  Vue.prototype.$eventBus = new Vue()

  new Vue({
    router,
    store,
    created() {
      this.$firebase.auth().onAuthStateChanged(auth => {
        if (auth && auth.emailVerified) {
          let path = ''
          if (window.navigator.userAgent.indexOf('Windows') !== -1) {
            path = 'recorders/windows/2018-06-21/WIN_D-Cipher_Record.zip'
          } else if (window.navigator.userAgent.indexOf('Mac') !== -1) {
            path = 'recorders/macos/18-06-07/MAC_D-Cipher_Record.dmg'
          }

          this.$storage
            .ref(path)
            .getDownloadURL()
            .then(url => {
              store.commit('setRecordDownloadURL', url)
            })

          this.$firestore
            .collection('users')
            .doc(auth.uid)
            .get()
            .then(doc => {
              const user = doc.data() || {}
              stats.init(auth, user, this.$firestore)
            })
        } else if (auth && !auth.emailVerified) {
          // TODO - Move to cloud function when sending email verification becomes available there
          if (auth.metadata.creationTime === auth.metadata.lastSignInTime) {
            auth.sendEmailVerification()
          }
          this.$router.push('/check-email')
        } else {
          this.$router.push('/')
        }
      })
    },
    render: h => h(App),
  }).$mount('#app')
})
